module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("History in 100 Chapters")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-1-in-the-beginning"
    }
  }, [_vm._v("Chapter 1: In the Beginning")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-2-african-origins"
    }
  }, [_vm._v("Chapter 2: African Origins")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#chapter-3-the-stone-age"
    }
  }, [_vm._v("Chapter 3: The Stone Age")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#chapter-4-the-bronze-age"
    }
  }, [_vm._v("Chapter 4: The Bronze Age")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch010#chapter-5-the-early-iron-age"
    }
  }, [_vm._v("Chapter 5: The Early Iron Age")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch011#chapter-6-egypt"
    }
  }, [_vm._v("Chapter 6: Egypt")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch012#chapter-7-the-indus-valley"
    }
  }, [_vm._v("Chapter 7: The Indus Valley")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch013#chapter-8-the-far-east-early-china-japan-and-korea"
    }
  }, [_vm._v("Chapter 8: The Far East: Early China, Japan and Korea")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch014#chapter-9-the-early-americas"
    }
  }, [_vm._v("Chapter 9: The Early Americas")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch015#chapter-10-the-medes-and-persians"
    }
  }, [_vm._v("Chapter 10: The Medes and Persians")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch016#chapter-11-agriculture-and-technology"
    }
  }, [_vm._v("Chapter 11: Agriculture and Technology")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch017#chapter-12-writing"
    }
  }, [_vm._v("Chapter 12: Writing")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch018#chapter-13-ancient-greece"
    }
  }, [_vm._v("Chapter 13: Ancient Greece")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch019#chapter-14-etruscans-to-romans"
    }
  }, [_vm._v("Chapter 14: Etruscans to Romans")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-15-roman-britain",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Roman Britain")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-16-rome-and-christianity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Rome and Christianity")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-17-societies-religions-and-christianity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Societies, Religions and Christianity")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-18-the-dark-ages",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: The Dark Ages")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-19-early-africa-and-asia",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Early Africa and Asia")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-20-arabia-and-islam",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Arabia and Islam")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#chapter-21-early-islam-and-arab-thinkers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: Early Islam and Arab Thinkers")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#chapter-22-the-late-dark-ages-in-britain-and-france",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: The Late Dark Ages in Britain and France")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#chapter-23-the-vikings-and-norsemen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: The Vikings and Norsemen")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#chapter-24-russia-the-early-years",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: Russia – The Early Years")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#chapter-25-the-norman-conquest-of-britain",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: The Norman Conquest of Britain")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#chapter-26-byzantine-empire",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26: Byzantine Empire")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#chapter-27-western-medieval-religion-and-the-crusades",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27: Western Medieval Religion and the Crusades")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#chapter-28-the-mongols",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28: The Mongols")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#chapter-29-england-1154-1485-the-plantagenets",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29: England 1154 – 1485 – The Plantagenets")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#chapter-30-europe-11th-to-14th-century",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30: Europe, 11"), _c('sup', [_vm._v("th")]), _vm._v(" to 14"), _c('sup', [_vm._v("th")]), _vm._v(" Century")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#chapter-31-the-medieval-arab-world",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31: The Medieval Arab World")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#chapter-32-medieval-empires",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32: Medieval Empires")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#chapter-33-early-maritime-exploration",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33: Early Maritime Exploration")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#chapter-34-exploration-west-from-europe",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34: Exploration West from Europe")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#chapter-35-exploration-east-from-europe",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35: Exploration East from Europe")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#chapter-36-printing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36: Printing")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#chapter-37-mapping",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 37: Mapping")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#chapter-38-the-tudors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 38: The Tudors")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch044#chapter-39-the-reformation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 39: The Reformation")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#chapter-40-the-renaissance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 40: The Renaissance")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#chapter-41-elizabeth-i-15331603",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 41: Elizabeth I 1533–1603")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch047#chapter-42-the-stuarts-and-civil-war",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 42: The Stuarts and Civil War")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch048#chapter-43-scotland-the-early-years",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 43: Scotland, the Early Years")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#chapter-44-wales",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 44: Wales")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch050#chapter-45-the-early-years-of-ireland",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 45: The Early Years of Ireland")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch051#chapter-46-early-european-emigration-to-north-america",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 46: Early European Emigration to North America")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch052#chapter-47-the-restoration",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 47: The Restoration")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch053#chapter-48-the-enlightenment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 48: The Enlightenment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch054#chapter-49-early-finance-and-banking",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 49: Early Finance and Banking")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch055#chapter-50-the-scientific-age",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 50: The Scientific Age")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch056#chapter-51-colonisation-of-north-and-central-america",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 51: Colonisation of North and Central America")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch057#chapter-52-art-through-the-ages",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 52: Art Through the Ages")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch058#chapter-53-literature-and-theatre",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 53: Literature and Theatre")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch059#chapter-54-music",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 54: Music")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch060#chapter-55-russia-from-1584",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 55: Russia from 1584")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch061#chapter-56-the-house-of-hanover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 56: The House of Hanover")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch062#chapter-57-the-second-great-age-of-exploration",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 57: The Second Great Age of Exploration")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch063#chapter-58-early-technology",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 58: Early Technology")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch064#chapter-59-slavery",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 59: Slavery")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch065#chapter-60-us-independence-to-civil-war",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 60: US Independence to Civil War")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch066#chapter-61-the-french-revolution",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 61: The French Revolution")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch067#chapter-62-britain-17601810",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 62: Britain 1760–1810")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch068#chapter-63-emerging-africa-japan-china-and-india",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 63: Emerging Africa, Japan, China and India")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch069#chapter-64-the-industrial-revolution",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 64: The Industrial Revolution")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch070#chapter-65-development-of-scientific-thought",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 65: Development of Scientific Thought")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch071#chapter-66-europe-after-napoleon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 66: Europe After Napoleon")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch072#chapter-67-britain-18201837",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 67: Britain 1820–1837")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch073#chapter-68-queen-victoria-to-1865",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 68: Queen Victoria to 1865")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch074#chapter-69-the-americas-in-the-19th-century",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 69: The Americas in the 19"), _c('sup', [_vm._v("th")]), _vm._v(" Century")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch075#chapter-70-development-of-the-british-empire",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 70: Development of the British Empire")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch076#chapter-71-physics-and-chemistry",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 71: Physics and Chemistry")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch077#chapter-72-development-of-biology-and-medicine",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 72: Development of Biology and Medicine")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch078#chapter-73-civil-engineering-roads-buildings-and-canals",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 73: Civil Engineering – Roads, Buildings and Canals")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch079#chapter-74-mechanical-and-transport-engineering",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 74: Mechanical and Transport Engineering")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch080#chapter-75-astronomy-and-navigation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 75: Astronomy and Navigation")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch081#chapter-76-the-far-east",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 76: The Far East")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch082#chapter-77-britain-18651901",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 77: Britain 1865–1901")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-83"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch083#chapter-78-the-united-kingdom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 78: The United Kingdom")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch084#chapter-79-19th-century-france",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 79: 19"), _c('sup', [_vm._v("th")]), _vm._v(" Century France")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-85"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch085#chapter-80-germany",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 80: Germany")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-86"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch086#chapter-81-usa-18651918",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 81: USA 1865–1918")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-87"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch087#chapter-82-urbanisation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 82: Urbanisation")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-88"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch088#chapter-83-edwardian-england-190114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 83: Edwardian England 1901–14")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-89"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch089#chapter-84-empires",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 84: Empires")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-90"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch090#chapter-85-emancipation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 85: Emancipation")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-91"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch091#chapter-86-legal-systems",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 86: Legal Systems")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-92"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch092#chapter-87-electrical-and-chemical-engineering",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 87: Electrical and Chemical Engineering")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-93"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch093#chapter-88-culture-16001914",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 88: Culture, 1600–1914")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-94"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch094#chapter-89-la-belle-epoque-development-of-science",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 89: La Belle Epoque – Development of Science")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-95"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch095#chapter-90-sleeping-eastern-giants-india-and-china",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 90: Sleeping Eastern Giants – India and China")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-96"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch096#chapter-91-world-war-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 91: World War 1")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-97"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch097#chapter-92-russian-and-chinese-revolutions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 92: Russian and Chinese Revolutions")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-98"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch098#chapter-93-brief-world-overview-of-the-20th-century",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 93: Brief World Overview of the 20"), _c('sup', [_vm._v("th")]), _vm._v(" Century")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-99"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch099#chapter-94-energy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 94: Energy")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-100"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch100#chapter-95-evolving-politics",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 95: Evolving Politics")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-101"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch101#chapter-96-climates-and-people",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 96: Climates and People")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-102"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch102#chapter-97-religion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 97: Religion")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-103"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch103#chapter-98-warfare",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 98: Warfare")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-104"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch104#chapter-99-world-population",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 99: World Population")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-105"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch105#chapter-100-global-warming",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 100: Global Warming")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0